import { render } from "./ListaFichDocComponent.vue?vue&type=template&id=0f374ab4"
import script from "./ListaFichDocComponent.vue?vue&type=script&lang=js"
export * from "./ListaFichDocComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/mac2/Herd/mix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__